import { Envelope } from "../geography.envelope";
import { GeoShape } from "./geography.shape";
import { GeoShapeType } from "./geography.shapes.interfaces";
export class GeoPolyline extends GeoShape {
    constructor(p, type) {
        super(type ?? GeoShapeType.Polyline);
        this._points = p;
    }
    get points() {
        return this._points;
    }
    _buildEnvelope() {
        return Envelope.FromPoints(...this._points);
    }
}
//# sourceMappingURL=geography.polyline.js.map